//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAllJobList, handleDelJob } from "@/api/managementCenter/jobManage";
export default {
  name: "leftJobList",
  data: function data() {
    return {
      loading: false,
      keywords: "",
      curItem: "",
      list: []
    };
  },
  mounted: function mounted() {
    this.getJobListFn();
  },
  methods: {
    handleAdd: function handleAdd() {
      this.$emit("handleAdd");
    },
    getJobListFn: function getJobListFn() {
      var _this = this;

      this.loading = true;
      getAllJobList().then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data || [];

          if (_this.list.length) {
            _this.switchItemFn(_this.list[0]);
          } else {
            _this.switchItemFn({});
          }
        } else {
          _this.$message.warning(data.msg || "获取岗位失败！");
        }
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    switchItemFn: function switchItemFn(item) {
      this.curItem = item.postId;
      this.$emit("selectJob", item);
    },
    openDetailFn: function openDetailFn(item) {
      this.$emit("openDetailFn", item);
    },
    // 删除
    handleDelFn: function handleDelFn(id) {
      var _this2 = this;

      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.deleteHttp(id);
      }).catch(function () {
        _this2.$message.info("已取消删除");
      });
    },
    deleteHttp: function deleteHttp(id) {
      var _this3 = this;

      this.loading = true; // 删除接口

      handleDelJob(id).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("删除成功!");

          _this3.getJobListFn();
        } else {
          _this3.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function () {
        _this3.loading = false;

        _this3.$message.error("删除异常!");
      });
    }
  }
};